import { getApplication } from './states';

export const services = {
  getApplication,
};
